<div class="drawer-container">
  <!-- Backdrop -->
  <div 
    class="backdrop" 
    *ngIf="isDrawerOpen" 
    (click)="closeDrawer()">
  </div>

  <!-- Custom Drawer -->
  <div 
    class="custom-drawer" 
    [class.drawer-open]="!!isDrawerOpen && isDrawerOpen"
    [class.drawer-right]="!isMobile"
    [class.drawer-bottom]="isMobile"
  >
    <div class="drawer-content">
      <h1 class="drawer-header text-muted">Order Summary</h1>

      <div *ngIf="showSkeletonLoader">
        <div class="item">
          <ngx-skeleton-loader
            count="5"
            [theme]="{ height: '25px' }"
          ></ngx-skeleton-loader>
        </div>
        <div class="item">
          <ngx-skeleton-loader
            count="5"
            [theme]="{ height: '25px' }"
          ></ngx-skeleton-loader>
        </div>
        <div class="item">
          <ngx-skeleton-loader
            count="5"
            [theme]="{ height: '25px' }"
          ></ngx-skeleton-loader>
        </div>
      </div>
      
      <div class="order-empty" *ngIf="!isOrder && !showSkeletonLoader">
        <img src="assets/images/empty-cart-icon.png" alt="Empty Cart">
        <h3>No orders found for the upcoming weeks.</h3>
      </div>

    <ng-container *ngIf="!!featureTags && !featureTags['sf_order_summary_color']">
      <mat-accordion *ngIf="isOrder && !showSkeletonLoader" [multi]="true">
        <mat-expansion-panel 
          *ngFor="let saleOrders of this.orderSummary; let i = index"
          [expanded]="i === 0"
          #panel >
          <mat-expansion-panel-header 
            class="order-summary-card-header"
            [ngClass]="{ 'header-open': panel.expanded, 'header-closed': !panel.expanded }"
          >
            <mat-panel-title>
              <ng-container *ngIf="!!featureTags && !featureTags['sf_my_order_timezone']">
                <span class="order-title" 
                      [ngClass]="{ 'title-open': panel.expanded, 'title-closed': !panel.expanded }">
                      {{ saleOrders['weeks'] }} <div class="order-title-date">({{ saleOrders['date_of_delivered'] | date: 'MMM d'}})</div>
                </span>
              </ng-container>
              <ng-container *ngIf="!!featureTags && featureTags['sf_my_order_timezone']">
                <span class="order-title" 
                      [ngClass]="{ 'title-open': panel.expanded, 'title-closed': !panel.expanded }">
                      {{ saleOrders['weeks'] }} <div class="order-title-date">({{ saleOrders['date_of_delivered'] | date: 'MMM d':'UTC'}})</div>
                </span>
              </ng-container>
            </mat-panel-title>
      
            <mat-panel-description
              [ngClass]="{ 'description-open': panel.expanded }"
            >
              <ng-container *ngIf="panel.expanded">
                <button mat-raised-button class="edit-order-btn" (click)="onEditOrderNavigation()" [routerLink]="['/edit-order']">Edit Order</button>
              </ng-container>
              <ng-container *ngIf="!panel.expanded">
                <span class="quantity-count">                  
                  <mat-icon>shopping_cart</mat-icon>
                  <span>{{ saleOrders['sale_order_items'].length }}</span>
                </span>
                <div class="order-total-header">
                  <span>
                    {{storeDetails['currency']}}
                  </span>                    
                    {{saleOrders['total_payable'] | number : '1.2-2'}}
                </div>
              </ng-container>
            </mat-panel-description>
          </mat-expansion-panel-header>
      
          <!-- Panel Content -->
          <div class="order-items">
            <ul>
              <li *ngFor="let item of saleOrders['sale_order_items']">
                <div class="order-item">
                  <span class="item-name">{{ item.description }} <span class="frequency" *ngIf="item['frequency'] != 'One Time Only'">{{item.frequency}}</span>
                  <ng-container *ngIf="!!featureTags && featureTags['sf_order_summary_soldout']">
                    <span class="stock-soldout" *ngIf="item['product']['stock_info']['restrict_orders'] === 1 && item['product']['stock_info']['stock_in_hand'] === 0"><mat-icon>clear</mat-icon>Sold Out</span>
                  </ng-container>
                  </span>
                  <span class="item-quantity">{{ item.quantity }}</span>
                  <span class="item-price">
                    <span>
                      {{storeDetails['currency']}}
                    </span>
                    {{item.extended_price | number : '1.2-2' }}
                  </span>
                </div>
              </li>
            </ul>
          </div>
          
          <!-- Total Price -->
          <ng-container *ngTemplateOutlet="totalPrice; context: { saleOrders: saleOrders }"></ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>
    <ng-container *ngIf="!!featureTags && featureTags['sf_order_summary_color']">
      <mat-accordion *ngIf="isOrder && !showSkeletonLoader" [multi]="true">
        <mat-expansion-panel 
          *ngFor="let saleOrders of this.orderSummary; let i = index"
          [expanded]="i === 0"
          #panel [ngStyle]="saleOrders?.cb_route_template ? {'border-left': '3px solid ' + saleOrders.cb_route_template.route_color} : {}"
        >
          <mat-expansion-panel-header 
            class="order-summary-card-header"
            [ngClass]="{ 'header-open': panel.expanded, 'header-closed': !panel.expanded }"
          >
            <mat-panel-title>
              <ng-container *ngIf="!!featureTags && !featureTags['sf_my_order_timezone']">
                <span class="order-title" 
                      [ngClass]="{ 'title-open': panel.expanded, 'title-closed': !panel.expanded }">
                      {{ saleOrders['weeks'] }} <div class="order-title-date">({{ saleOrders['date_of_delivered'] | date: 'MMM d'}})</div>
                </span>
              </ng-container>
              <ng-container *ngIf="!!featureTags && featureTags['sf_my_order_timezone']">
                <span class="order-title" 
                      [ngClass]="{ 'title-open': panel.expanded, 'title-closed': !panel.expanded }">
                      {{ saleOrders['weeks'] }} <div class="order-title-date">({{ saleOrders['date_of_delivered'] | date: 'MMM d':'UTC'}})</div>
                </span>
              </ng-container>
            </mat-panel-title>
      
            <mat-panel-description
              [ngClass]="{ 'description-open': panel.expanded }"
            >
              <ng-container *ngIf="panel.expanded">
                <button mat-raised-button class="edit-order-btn" (click)="onEditOrderNavigation()" [routerLink]="['/edit-order']">Edit Order</button>
              </ng-container>
              <ng-container *ngIf="!panel.expanded">
                <span class="quantity-count">                  
                  <mat-icon>shopping_cart</mat-icon>
                  <span>{{ saleOrders['sale_order_items'].length }}</span>
                </span>
                <div class="order-total-header">
                  <span>
                    {{storeDetails['currency']}}
                  </span>                    
                    {{saleOrders['total_payable'] | number : '1.2-2'}}
                </div>
              </ng-container>
            </mat-panel-description>
          </mat-expansion-panel-header>
      
          <!-- Panel Content -->
          <div class="order-items">
            <ul>
              <li *ngFor="let item of saleOrders['sale_order_items']">
                <div class="order-item">
                  <span class="item-name">{{ item.description }} <span class="frequency" *ngIf="item['frequency'] != 'One Time Only'">{{item.frequency}}</span>
                  <ng-container *ngIf="!!featureTags && featureTags['sf_order_summary_soldout']">
                    <span class="stock-soldout" *ngIf="item['product']['stock_info']['restrict_orders'] === 1 && item['product']['stock_info']['stock_in_hand'] === 0"><mat-icon>clear</mat-icon>Sold Out</span>
                  </ng-container>
                  </span>
                  <span class="item-quantity">{{ item.quantity }}</span>
                  <span class="item-price">
                    <span>
                      {{storeDetails['currency']}}
                    </span>
                    {{item.extended_price | number : '1.2-2' }}
                  </span>
                </div>
              </li>
            </ul>
          </div>
          
          <!-- Total Price -->
          <ng-container *ngTemplateOutlet="totalPrice; context: { saleOrders: saleOrders }"></ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>
    </div>
    
    <div 
      type="button"
      class="drawer-toggle-button"
      [class.button-mobile]="isMobile"
      [class.button-desktop]="!isMobile"
      (click)="toggleDrawer()"
    >
      <div class="bg">
        <img src="assets/images/others/drawer_btn.svg" alt="Order Summary Button">
      </div>
      <div class="arrowIcon" *ngIf="isMobile">
        <mat-icon *ngIf="!isDrawerOpen">arrow_left</mat-icon>
        <mat-icon *ngIf="isDrawerOpen">arrow_right</mat-icon>
      </div>
      <div class="truckIcon" *ngIf="!isMobile">
        <img src="assets/images/truck_delivery.png" alt="Truck Delivery">
      </div>
    </div>
  </div>

</div>


<ng-template #totalPrice let-saleOrders="saleOrders">
  <!-- Total Price -->
  <div class="details">
    <div class="details__container" (click)="toggleDetails(saleOrders['id'])" [ngClass]="{'opened': priceDetailsOpened[saleOrders['id']]}">
      <div class="details__summary">
        <!-- The title -->              
        <div class="total-price-div details__title">
          <!-- Order Total -->
          <div class="total-price-text">Order Total:</div>
          <div class="total-price">
            <span>
              {{storeDetails['currency']}}
            </span>
            <span>              
              {{saleOrders['total_payable'] | number : '1.2-2'}}
            </span>
          </div>
          <!-- Order SubTotal -->
          <div class="subTotal-price-text">Order Subtotal:</div>
          <div class="subTotal-price">
            <span>
              {{storeDetails['currency']}}
            </span>                    
              {{saleOrders['sub_total'] | number : '1.2-2'}}
          </div>
        </div>
      </div>
    </div>
    <!-- The content -->
    <div class="details__desc">
      <div class="details__desc-inner">
        <div class="price-row">
          <span class="price-row-title">Bottle ({{ saleOrders['bottle_delivered']}} @ {{storeDetails['currency']}}{{storeDetails['rate_per_bottle'] | number : '1.2-2'}}):</span>
          <span class="price-row-amount">{{storeDetails['currency']}}{{ storeDetails['rate_per_bottle'] * saleOrders['bottle_delivered'] | number : '1.2-2' }}</span>
        </div>
        <div class="price-row">
          <span class="price-row-title">Delivery Fees:</span>
          <span class="price-row-amount">{{storeDetails['currency']}}{{saleOrders['delivery_fee'] | number : '1.2-2' }}</span>
        </div>
        <div class="price-row">
          <span class="price-row-title">Tax Collected:</span>
          <span class="price-row-amount">{{storeDetails['currency']}}{{saleOrders['tax_collected'] | number: '1.2-2' }}</span>
        </div>
        <div class="price-row">
          <span class="price-row-title">Tip Amount:</span>
          <span class="price-row-amount">{{storeDetails['currency']}}{{saleOrders['tip_amount'] | number: '1.2-2' }}</span>
        </div>                          
        <div class="price-row">
          <span class="price-row-title">Order Total:</span>
          <span class="total-price">{{storeDetails['currency']}} {{saleOrders['total_payable'] | number : '1.2-2'}}</span>
        </div>                          
      </div>
    </div>
  </div>
</ng-template>